const STORAGE_KEY = 'um_pending_invitation_id';

export function getPendingInvitationId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setPendingInvitationId(invitationId: string): void {
  if (!invitationId) return;
  try {
    localStorage.setItem(STORAGE_KEY, invitationId);
  } catch {
    // ignore storage failures (private mode, disabled storage, etc.)
  }
}

export function clearPendingInvitationId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
